/* eslint-disable react/forbid-prop-types */
import React from 'react';
import {
  Typography,
  ModalBody
} from '@one-thd/sui-atomic-components';
import moment from 'moment';
import { bool, func, object, string } from 'prop-types';
import { Location } from '@one-thd/sui-icons';
import WrappedFields from './WrappedFields';

function FormContent({
  setRegistrationData, workshopsData, storeData, setModalPage, svocId
}) {

  const store = storeData?.storeSearch.stores[0];

  const handleRegister = async (info) => {
    setModalPage('loading');
    const url = '/workshops/rs/participant';
    const splitName = info.name.trim().split(' ');
    const firstName = splitName[0];
    const lastName = splitName[1] || '';
    const formattedStartDate = moment(info.workshop.startDate).utc().format('YYYY-MM-DD[T]HH:mm:ss') + 'Z';
    const formattedEndDate = moment(info.workshop.endDate).utc().format('YYYY-MM-DD[T]HH:mm:ss') + 'Z';
    const body = [{
      firstName,
      lastName,
      email: info.email.toLowerCase(),
      svocId: svocId || '123',
      numberOfParticipants: info.participants || 1,
      workshop: {
        id: info.workshop.id,
        name: info.workshop.name,
        storeId: info.workshop.storeId,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        description: info.workshop.description,
        type: info.workshop.type,
        imagePath: info.workshop.imagePath
      },
      store: {
        storeId: store.storeId,
        name: store.name,
        phone: store.phone,
        address: store.address,
      }
    }];

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });

    const apiData = await response.status;
    if (apiData === 200) {
      setModalPage('success');
      setRegistrationData({
        name: firstName + ' ' + lastName,
        numOfParticipants: info.participants,
        storeId: store.storeId,
        storeName: store.name,
        workshop: info.workshop.name,
        date: info.workshop.startDate,
        address: store.address
      });
    }
  };

  return (
    <div className="sui-grid sui-gap-4">
      <ModalBody>
        <div className="sui-grid sui-grid-cols-1">
          <Typography variant="body-base" weight="regular"><Location /> <span>{store?.name} #{store?.storeId}</span>
          </Typography>
        </div>
        <div className="sui-grid sui-grid-cols-1 sui-mt-5">
          <Typography variant="body-base" weight="regular">

            <span className="sui-text-subtle">Need a different location?
              Update your store and try registering again.
            </span>
          </Typography>
        </div>
        <WrappedFields
          onSubmit={handleRegister}
          workshopsData={workshopsData}
        />
      </ModalBody>
    </div>
  );
}

FormContent.propTypes = {
  setRegistrationData: func.isRequired,
  workshopsData: object.isRequired,
  storeData: object.isRequired,
  setModalPage: bool.isRequired,
  svocId: string.isRequired
};

export default FormContent;
